import React from 'react'
import { Button, Menu, MenuItem, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { RoutesPath } from '../../constants/RoutesPath'
import { Colors } from '../../constants/Colors'
import { capitalizeEachWord, replace } from '../../utils/TextUtil'

const getDisplayName = (path: string) =>
   capitalizeEachWord(
      replace(path === RoutesPath.HOME ? 'home' : path, RoutesPath.HOME, '')
   )

export const DesktopNavigation = ({
   navigateTo,
}: {
   navigateTo: (path: string) => void
}) => (
   <>
      {Object.values(RoutesPath).map(path => (
         <Button
            color="inherit"
            id={path}
            key={path}
            onClick={() => navigateTo(path)}
            sx={{ color: Colors.BLACK, mx: 2 }}
         >
            {getDisplayName(path)}
         </Button>
      ))}
   </>
)

export const MobileNavigation = ({
   navigateTo,
   anchorEl,
   open,
   handleClick,
   handleClose,
}: {
   navigateTo: (path: string) => void
   anchorEl: HTMLElement | null
   open: boolean
   handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
   handleClose: () => void
}) => (
   <>
      <IconButton
         id="basic-button"
         aria-controls={open ? 'basic-menu' : undefined}
         aria-haspopup="true"
         aria-expanded={open ? 'true' : undefined}
         onClick={handleClick}
         sx={{ color: Colors.BLACK }}
      >
         <MenuIcon />
      </IconButton>
      <Menu
         id="basic-menu"
         anchorEl={anchorEl}
         open={open}
         onClose={handleClose}
         MenuListProps={{
            'aria-labelledby': 'basic-button',
         }}
      >
         {Object.values(RoutesPath).map(path => (
            <MenuItem
               color="inherit"
               id={path}
               key={path}
               onClick={() => {
                  handleClose()
                  navigateTo(path)
               }}
               sx={{ color: Colors.BLACK, mx: 2 }}
            >
               {getDisplayName(path)}
            </MenuItem>
         ))}
      </Menu>
   </>
)
